module.exports = __webpack_public_path__ + "static/media/telemedicine_video.388b93ab.mp4";